import React, { Suspense, lazy } from "react";

import { Link, useParams, Navigate } from "react-router-dom";

import SEO from "../../components/SEO";

import AdSlot from "../../components/AdSlot";

import { ToolIcon } from "../../lib/toolIcons";

import { getToolBySlug, tools } from "../../data/tools";

import {

  breadcrumbSchema,

  getToolPageMeta,

  webApplicationSchema,

} from "../../lib/seo";



const DocToPdfTool = lazy(() => import("../../tools/DocToPdfTool"));

const ImageToPdfTool = lazy(() => import("../../tools/ImageToPdfTool"));

const UrlDownloaderTool = lazy(() => import("../../tools/UrlDownloaderTool"));

const VideoToMp3Tool = lazy(() => import("../../tools/VideoToMp3Tool"));



const ToolLoader = () => (

  <div className="glass-panel p-8 text-center text-gray-400">Loading tool...</div>

);



const ToolPage = () => {

  const { slug } = useParams();

  const tool = getToolBySlug(slug);



  if (!tool) return <Navigate to="/tools" replace />;



  const meta = getToolPageMeta(tool);



  const renderTool = () => {

    switch (tool.slug) {

      case "doc-to-pdf":

        return <DocToPdfTool />;

      case "image-to-pdf":

        return <ImageToPdfTool />;

      case "video-to-mp3":

        return <VideoToMp3Tool />;

      case "youtube-downloader":

      case "instagram-downloader":

      case "twitter-downloader":

        return <UrlDownloaderTool tool={tool} />;

      default:

        return null;

    }

  };



  const related = tools.filter((t) => t.slug !== tool.slug).slice(0, 3);



  return (

    <>

      <SEO

        title={meta.title}

        description={meta.description}

        keywords={meta.keywords}

        path={meta.path}

        ogType="website"

        jsonLd={[

          webApplicationSchema(tool),

          breadcrumbSchema([

            { name: "Home", path: "/" },

            { name: "Daily Innovations", path: "/tools" },

            { name: tool.title, path: meta.path },

          ]),

        ]}

      />

      <article className="pt-28 pb-20 min-h-screen bg-dark-400">

        <div className="section-container">

          <nav aria-label="Breadcrumb" className="mb-6">

            <ol className="flex flex-wrap items-center gap-2 text-sm text-gray-500">

              <li>

                <Link to="/" className="hover:text-primary-400 transition-colors">

                  Home

                </Link>

              </li>

              <li aria-hidden="true">/</li>

              <li>

                <Link to="/tools" className="hover:text-primary-400 transition-colors">

                  Daily Innovations

                </Link>

              </li>

              <li aria-hidden="true">/</li>

              <li className="text-gray-400" aria-current="page">

                {tool.title}

              </li>

            </ol>

          </nav>



          <div className="grid lg:grid-cols-12 gap-8 lg:gap-10">

            <div className="lg:col-span-3 hidden lg:block">

              <AdSlot size="sidebar" />

            </div>



            <div className="lg:col-span-6">

              <header className="mb-8">

                <ToolIcon slug={tool.slug} className="w-10 h-10 text-primary-400 mb-4" />

                <h1 className="font-display text-3xl md:text-4xl font-bold text-white mb-3">

                  {tool.title}

                </h1>

                <p className="text-gray-400 mb-3">{tool.description}</p>

                {tool.seoIntro && (

                  <p className="text-gray-500 text-sm leading-relaxed">{tool.seoIntro}</p>

                )}

              </header>



              <AdSlot size="banner" className="mb-8 lg:hidden" />



              <Suspense fallback={<ToolLoader />}>{renderTool()}</Suspense>



              <AdSlot size="rectangle" className="mt-10" />

            </div>



            <aside className="lg:col-span-3" aria-label="Related tools">

              <div className="glass-panel p-5 sticky top-28">

                <h2 className="font-display font-semibold text-white mb-4 text-sm">

                  More Tools

                </h2>

                <ul className="space-y-3">

                  {related.map((t) => (

                    <li key={t.slug}>

                      <Link

                        to={`/tools/${t.slug}`}

                        className="flex items-center gap-2 text-sm text-gray-400 hover:text-primary-400 transition-colors"

                      >

                        <ToolIcon slug={t.slug} className="w-4 h-4 flex-shrink-0" />

                        <span>{t.title}</span>

                      </Link>

                    </li>

                  ))}

                </ul>

                <Link

                  to="/tools"

                  className="block mt-5 text-sm text-primary-400 hover:text-primary-300"

                >

                  View all free online tools →

                </Link>

              </div>

            </aside>

          </div>



          <footer className="mt-12 pt-8 border-t border-white/5">

            <p className="text-xs text-gray-600">

              Tags: {tool.tags?.join(", ")} · Free online tool by Purpose Labs

            </p>

          </footer>

        </div>

      </article>

    </>

  );

};



export default ToolPage;

